import { useQuery, UseQueryResult } from 'react-query';
import { DealReportDto } from '../../services/dtos/dealReport/dealReport.dto';
import { fetchDealReport } from '../../services/dealReport/dealReport.service';
import { ApiError } from '../../services/api-error.model';
import { queryKeys } from '../queryKeyFactory';

export default (reportId: number | null): UseQueryResult<DealReportDto | undefined, ApiError> => {
  return useQuery<DealReportDto, ApiError>(queryKeys.fetchDealReport.singleById(reportId), async () =>
    fetchDealReport(reportId)
  );
};
